import axios from 'axios';
import emitter, { EVENT_TYPES } from '@/utils/events';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Force clear any stored auth data
      localStorage.removeItem("userData");
      
      // Emit an authentication error event that will be handled by the app
      emitter.emit(EVENT_TYPES.AUTH_ERROR, error.response?.data?.message || 'Authentication required');
      
      // If we're not already on the login page, redirect to it
      if (window.location.pathname !== '/login') {
        localStorage.setItem('intendedRoute', window.location.pathname);
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api; 
